import React, { useEffect } from "react"
import PropTypes from "prop-types"
import getDisplayName from "@material-ui/utils/getDisplayName"
import hoistNonReactStatics from "hoist-non-react-statics"

import { isDevelopment } from "constants/internal"
import connect from "./connect"

const withLoggedInUser =
    ({ stripped = false } = {}) =>
    WrappedComponent => {
        function WithLoggedInUser({
            loadUser,
            loadingLoggedInUserError,
            isLoadingLoggedInUser,
            hasFetchedLoggedInUser,
            isLoggedIn,
            ...props
        }) {
            useEffect(() => {
                if (
                    !isLoadingLoggedInUser &&
                    !hasFetchedLoggedInUser &&
                    !loadingLoggedInUserError &&
                    isLoggedIn
                ) {
                    loadUser()
                }
            }, [
                loadingLoggedInUserError,
                isLoadingLoggedInUser,
                hasFetchedLoggedInUser,
                isLoggedIn,
            ])

            return <WrappedComponent {...props} />
        }

        WithLoggedInUser.propTypes = {
            loadUser: PropTypes.func.isRequired,
            loadingLoggedInUserError: PropTypes.object,
            isLoadingLoggedInUser: PropTypes.bool,
            hasFetchedLoggedInUser: PropTypes.bool,
            isLoggedIn: PropTypes.bool,
        }
        WithLoggedInUser.defaultProps = {
            loadingLoggedInUserError: null,
            isLoadingLoggedInUser: false,
            hasFetchedLoggedInUser: false,
            isLoggedIn: false,
        }

        if (isDevelopment) {
            WithLoggedInUser.displayName = `WithLoggedInUser(${getDisplayName(
                WrappedComponent,
            )})`
        }

        hoistNonReactStatics(WithLoggedInUser, WrappedComponent)

        return stripped ? WithLoggedInUser : connect(WithLoggedInUser)
    }

export default withLoggedInUser
